"use strict";

exports.__esModule = true;
var _TimeFormatSelector = require("./TimeFormatSelector");
Object.keys(_TimeFormatSelector).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TimeFormatSelector[key]) return;
  exports[key] = _TimeFormatSelector[key];
});